import Image from "next/image"
import drivers from "./drivers.json"
import drivers_ar from "./drivers_ar.json"


// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import { useLang } from "hooks/useLang"

const RenderDrivers = ({ setSideBarComponent, onShowSidebar }: any) => {
    const { t, lang } = useLang()
    const data = lang === "ar" ? drivers_ar : drivers
    return (
        <div className="flex flex-row rounded-2xl select-none h-[220px] pb-0.5 gap-6  py-1 ">

            {data.map((driver, index) => (

                <div key={index} className="h-[212px] w-[161px] cursor-pointer" onClick={() => {
                    onShowSidebar()
                    setSideBarComponent(() => (
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col">
                                <span className="font-[700] text-black text-[30px] flex-1">
                                    {driver.name}
                                </span>
                                <span className="font-[400] text-black text-[18px]">
                                    {driver.country}
                                </span>
                            </div>
                            <div className="flex flex-col w-full items-center justify-center">
                                {driver.header && (
                                    <Image
                                        className="w-full"
                                        alt={driver.name}
                                        src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + driver.header}
                                        width={500}
                                        height={300}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                        }}
                                        priority
                                    />
                                )}
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("team")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.team}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("points")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.points ?? 0}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("podiums")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.podiums}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("grand_prix_entered")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.grand_prix_entered}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("highest_race_finish")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.highest_race_finish}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("place_of_birth")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.place_of_birth}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="capitalize font-bold">
                                        {t("date_of_birth")}
                                    </span>
                                    <span className="capitalize">
                                        {driver.date_of_birth}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                }}>
                    <DriverComponent index={index} src={driver.src} />
                </div>
            ))}

        </div>
    )
}

const DriverComponent = ({ index, src }: { index: number, src: string }) => {
    return <div className={`relative gap-2  flex  w-[270px] h-[200px] shadow-md rounded-[5px]`}>
        <div className="absolute inset-0 z-10 rounded-[5px]" />
        <Image
            className=" cursor-auto  "


            src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + src}
            alt={`F1 Driver ${index + 1}`}
            width={161}
            height={212}
            style={{
                objectFit: "cover",

            }}
        />

    </div>
}

export default RenderDrivers